import {Spin} from 'antd';
import React from 'react';

const Loading = (props) => {
  return (
    <Spin spinning={props?.isOpen || false} fullscreen size="large" description="loading..." />
  );
};

export default Loading;
